import { __decorate, __metadata } from "tslib";
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsString } from 'class-validator';
import { IsUndefinable, ToArray } from '@goparrot/common';
import { LogicalOperatorEnum } from '../../common';
import { PromotionExposeGroup } from '../interface';
export class ApplicablePromotionsFilterDto {
}
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    Type(() => Boolean),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ApplicablePromotionsFilterDto.prototype, "isApplied", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    Type(() => Boolean),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ApplicablePromotionsFilterDto.prototype, "isApplicable", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    ToArray(undefined, { groups: [PromotionExposeGroup.READ], toClassOnly: true }),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    __metadata("design:type", Array)
], ApplicablePromotionsFilterDto.prototype, "tags", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    IsUndefinable({ always: true }),
    IsEnum(LogicalOperatorEnum, { always: true }),
    __metadata("design:type", String)
], ApplicablePromotionsFilterDto.prototype, "tagsLogicalOperator", void 0);
__decorate([
    Expose({ groups: [PromotionExposeGroup.READ] }),
    IsUndefinable({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ApplicablePromotionsFilterDto.prototype, "storeId", void 0);
//# sourceMappingURL=ApplicablePromotionsFilterDto.js.map